import { render, staticRenderFns } from "./AdvertisingModal.vue?vue&type=template&id=7855b539&scoped=true&"
import script from "./AdvertisingModal.vue?vue&type=script&lang=js&"
export * from "./AdvertisingModal.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingModal.vue?vue&type=style&index=0&id=7855b539&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7855b539",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
